import type { SessionType } from '~/types'

import type { Options } from '../useInternalApi'

import { useInternalApi } from '../useInternalApi'

export const useFetchSession = <
  TAuthData,
  TSessionData,
  TAuthPayload extends Record<string, any>,
>(sessionType: SessionType) => {
  const { post, get, getUrl } = useInternalApi()

  const authenticate = async ({
    payload,
    options = {},
  }: {
    payload: TAuthPayload
    options?: Options
  }) =>
    post<TAuthData>({
      url: getUrl(sessionType, 'sessions/authenticate'),
      options: {
        body: payload,
        ...options,
      },
    }).then(res => res.data)

  const getCurrent = ({ options }: { options?: Options } = {}) =>
    get<TSessionData>({
      url: getUrl(sessionType, 'sessions/current'),
      accessType: sessionType,
      options,
    }).then(res => res.data)

  return {
    getCurrent,
    authenticate,
  }
}
